import { z, ZodIssueCode } from 'zod';
import { changePasswordFormSchemaMessages as messages } from './messages';

export const changePasswordFormSchema = z
  .object({
    currentPassword: z.string().min(1, messages.required),
    newPassword: z.string().min(1, messages.required),
    passwordConfirmation: z.string().min(1, messages.required),
  })
  .superRefine(({ currentPassword, newPassword, passwordConfirmation }, { addIssue }) => {
    if (newPassword !== passwordConfirmation) {
      addIssue({
        code: ZodIssueCode.custom,
        message: messages.invalidPasswordConfirmation,
        path: ['passwordConfirmation'],
      });
    }

    if (currentPassword === newPassword) {
      addIssue({
        code: ZodIssueCode.custom,
        message: messages.nonDifferentNewPassword,
        path: ['newPassword'],
      });
    }
  });
